export * from './baMenuItem.component';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/components/baMenu/components/baMenuItem/index.ts